/*
 *   File :  success-confirmation.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description :  Success confirmation order
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useState, useEffect } from 'react';

/*import styles*/
import styles from '../../styles/components/fundClass.module.scss';
import { SecondaryBtn, PrimaryBtn } from '../cta';

import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import { Toast } from '../note';

/*import components*/

export default function SendAgainMessage(props) {

    const [toastMessage, setToastMessage] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("send-again-message-modal");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.handleCloseModal();
        });
        //eslint-disable-next-line
    }, [props.handleCloseDateModal]);

    useEffect(() => {
        if (toastMessage !== null) {
            setTimeout(() => {
                setToastMessage(null);
            }, 4000);
        }
    }, [toastMessage])

    const _handleCloseModal = () => {
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
    };

    const _openEdit = () => {
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
        props.openEdit(props.data);
    }


    return (
        <div className={`${styles.e_add_fund} modal fade`}
            id={"send-again-message-modal"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="send-again-message-modal"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className="modal-content">
                    <button id="close-pscm"
                        type="button"
                        className="btn-close d-none"
                        data-bs-dismiss="modal"
                        onClick={_handleCloseModal} >
                    </button>
                    <img src={require("../../assets/images/modal/sendAgain.png").default}
                        alt="success"
                        width={62}
                        height={62}
                        className='mx-auto mt-1' />
                    <h6 className={`pt-4 mt-3 px-5 mb-4 pb-2 text-center ${styles.e_sendagain_confirm}`} style={{ whiteSpace: "pre-line" }}>
                        This will create a <b>cloned copy of this event and open it in edit mode</b>.<br/> You can review and update the audience, message content, schedule, and other details before sending it.
                    </h6>
                    <div className="row pb-1">
                        <div className="col-lg-12">
                            <div className="d-flex justify-content-center gap-3">
                                <SecondaryBtn
                                    name="Clone & open in edit mode"
                                    className={loader ? "e-btn-loader e-disabled e-modal-submit-blue" : 'e-modal-submit-blue'}
                                    handleClick={_openEdit} />


                                <SecondaryBtn
                                    name="Cancel"
                                    className={`${styles.e_cancel} e-cancel`}
                                    cancel="modal" />
                            </div>

                        </div>
                    </div>
                </div>
            </div >
            {
                toastMessage !== null ?
                    <Toast data={toastMessage.message}
                        type={toastMessage.type}
                        id="2" />
                    :
                    null
            }
        </div>

    )
}
